import {
  ADD_PAGE_STARTED,
  ADD_PAGE_COMPLETED,
  ADD_PAGE_ERROR
} from '../actionTypes/pageActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  currentPage: '',
};

function pageReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PAGE_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_PAGE_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          currentPage: action.payLoad,
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case ADD_PAGE_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default pageReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/pageReducer.js